var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-user"},[_c('Overlay',{attrs:{"width":"small","link":{name: 'users'}}},[_c('user-form',{attrs:{"companies":_vm.companyOptions,"availablePermissions":_vm.availablePermissions,"errors":_vm.errors},on:{"submit":_vm.submit},model:{value:(_vm.user),callback:function ($$v) {_vm.user=$$v},expression:"user"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }